import Cookies from '../3p/js-cookie.min.js';

/**
 * Browser-side counterpart of util/ApiEndpoint.php: which API backend a locally-running web
 * frontend targets. An engineer picks per-browser on the /dev page, which stores the choice
 * in a cookie; deployed pages never consult it (APIRequest resolves them straight to Prod).
 * The value constants and cookie name are a shared contract with the PHP enum and the
 * <option> values in DevPage.twig — keep them in sync.
 */
export class ApiEndpoint {
    static CookieName = "apiEndpoint";
    static Staging = "staging";
    static Dev = "dev";
    static Prod = "prod";

    /**
     * Reads the selection from the cookie. Absent or unrecognized values (including stale
     * useStaging-era cookies) fall back to Staging, so a fresh checkout renders real content
     * without a local API running.
     * @returns {string} One of the endpoint value constants.
     */
    static current() {
        const value = Cookies.get(ApiEndpoint.CookieName);
        if (value === ApiEndpoint.Dev || value === ApiEndpoint.Prod) {
            return value;
        }
        return ApiEndpoint.Staging;
    }

    /**
     * Persists the selection for this browser. Long-lived: an engineer's choice should
     * survive across sessions until they change it on /dev.
     * @param {string} value One of the endpoint value constants.
     */
    static select(value) {
        Cookies.set(ApiEndpoint.CookieName, value, { expires: 365, path: "/" });
    }

    /**
     * Browser-side base URL for an endpoint. Dev builds from the page hostname so
     * phone-on-LAN testing reaches the dev machine rather than the phone itself. The prod
     * origin intentionally differs from the server-side one (browser traffic goes through
     * the public API domain).
     * @param {string} value One of the endpoint value constants.
     * @returns {string} The base URL, with a trailing slash.
     */
    static url(value) {
        if (value === ApiEndpoint.Dev) {
            return `http://${window.location.hostname}:8080/`;
        }
        if (value === ApiEndpoint.Prod) {
            return "https://api.collectiveapp.com/";
        }
        return "https://staging-dot-creator-testing.appspot.com/";
    }
}
